module.exports = __webpack_public_path__ + "img/in-stock_guarantee.39a75802.png";